import { Card } from '../models/Card';
import { Deck } from '../models/Deck';
import { DeckConfig } from '../models/DeckConfig';
import { StackCard } from '../models/StackCard';
import CardView from './CardView';
import EmptyCard from './EmptyCard';

const NormalCards = (props: { deck: Deck, selectedCard: Card | null, removeNormalCard: (card: Card) => any, markFavoriteCard: (card: Card) => any, onCardCountChanged?: (stackCard: StackCard, newValue: number) => any, onClicked: (card?: Card) => any; }) => {

    return <>
        {
            props.deck.normalCards.map((stackCard) =>
                <CardView
                    key={stackCard.card.uuid}
                    stackCard={stackCard}
                    isFavorite={false}
                    isCardSelected={stackCard.card.uuid === props.selectedCard?.uuid}
                    onRemoveCard={props.removeNormalCard}
                    onMarkFavoriteCard={props.markFavoriteCard}
                    onUnmarkFavoriteCard={null}
                    onCardCountChanged={props.onCardCountChanged}
                    onClicked={props.onClicked} />
            )
        }
        {
            DeckConfig.DeckTotalCount > (props.deck.totalCardCount)
                ? <EmptyCard key="empty-card" /> : null
        }
        <div className='flex-adjust-element' />
        <div className='flex-adjust-element' />
        <div className='flex-adjust-element' />
        <div className='flex-adjust-element' />
        <div className='flex-adjust-element' />
        <div className='flex-adjust-element' />
        <div className='flex-adjust-element' />
        <div className='flex-adjust-element' />
        <div className='flex-adjust-element' />
        <div className='flex-adjust-element' />
        <div className='flex-adjust-element' />
        <div className='flex-adjust-element' />
    </>;
};

export default NormalCards;